import spiderman from '@/spiderman/index';

async function bind(member, memberInfo) {
  return (
    await spiderman.axios.post(spiderman.api.membership,
      {
        twid: memberInfo.twid,
        birthdate: memberInfo.birthdate,
        mobile: memberInfo.mobile,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function verify(member, memberInfo) {
  return (
    await spiderman.axios.put(spiderman.api.membership,
      {
        twid: memberInfo.twid,
        birthdate: memberInfo.birthdate,
        mobile: memberInfo.mobile,
        bindingCode: memberInfo.bindingCode,
        password: memberInfo.password,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  bind,
  verify,
};
